// extracted by mini-css-extract-plugin
module.exports = {"label":"DuplicateOrdersModal_label__667nO"};